import i18n from '@/i18n';
import context from '../main';
import { v4 as uuid } from 'uuid';

const forge = require('node-forge');
const { util } = forge;

/*eslint-disable*/
export function httpString(s) {
  var reg = /(http:\/\/|https:\/\/)?((\w|=|\?|\.|\/|&|-)+)/g;

  s = s.match(reg);

  return s.filter(_ => _.indexOf('www') > -1);
}

export function removedDot(s) {
  if (s.endsWith('.')) {
    return s.slice(0, s.length - 1);
  }
  return s;
}

const getI18nLanguageName = str => {
  return str.slice(0, str.indexOf('_'));
};
const getBrowserLanguageName = str => {
  return str.slice(0, str.indexOf('-'));
};

const showFirstChar = str => {
  return str.substring(0, 1) + new Array(str.length).join('*');
};

const getFirst4andLast2Num = str => {
  // eslint-disable-next-line func-style
  function abc(match, p1, p2) {
    let a = '';
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i <= p1.length; i++) {
      a += '*';
    }
    return a + p2;
  }

  return str.replace(/(\d*)(\d{4}$)/, abc);
};

const getEmailBeforeAt = str => {
  if (!str) return null;
  const atIndex = str.indexOf('@');
  const afterAtIndex = str.slice(atIndex);
  const charBeforeAt = str.slice(0, atIndex);
  // @前面为1-6位
  if (charBeforeAt.length <= 6) {
    // eslint-disable-next-line no-unused-vars
    let charBeforeAtChange = '';
    // eslint-disable-next-line no-plusplus
    for (let i = 1; i < charBeforeAt.length; i++) {
      charBeforeAtChange += '*';
    }
    if (charBeforeAtChange.length > 4) charBeforeAtChange = '****';
    return charBeforeAt[0] + charBeforeAtChange + afterAtIndex;
  }
  // @前面为7-9位
  if (charBeforeAt.length <= 9 && charBeforeAt.length >= 7) {
    // eslint-disable-next-line no-unused-vars
    let charBeforeAtChange = '';
    // eslint-disable-next-line no-plusplus
    for (let i = 2; i < charBeforeAt.length; i++) {
      charBeforeAtChange += '*';
    }
    if (charBeforeAtChange.length > 4) charBeforeAtChange = '****';
    return charBeforeAt[0] + charBeforeAt[1] + charBeforeAtChange + afterAtIndex;
  }
  // @前面大于10位
  if (charBeforeAt.length >= 10) {
    // eslint-disable-next-line no-unused-vars
    let charBeforeAtChange = '';
    // eslint-disable-next-line no-plusplus
    for (let i = 3; i < charBeforeAt.length; i++) {
      charBeforeAtChange += '*';
    }
    if (charBeforeAtChange.length > 4) charBeforeAtChange = '****';
    return charBeforeAt[0] + charBeforeAt[1] + charBeforeAt[2] + charBeforeAtChange + afterAtIndex;
  }
};

const getQueryString = name => {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  const r = window.location.search.substr(1).match(reg);
  if (r !== null) return decodeURI(r[2]);
  return null;
};

const scroll = (currentY, targetY) => {
  // 计算需要移动的距离
  const needScrollTop = targetY - currentY;
  // eslint-disable-next-line no-underscore-dangle
  let _currentY = currentY;
  let timer = setTimeout(() => {
    // 一次调用滑动帧数，每次调用会不一样
    const dist = Math.ceil(needScrollTop / 10);
    _currentY += dist;
    window.scrollTo(_currentY, currentY);
    // 如果移动幅度小于十个像素，直接移动，否则递归调用，实现动画效果
    if (needScrollTop > 10 || needScrollTop < -10) {
      scroll(_currentY, targetY);
    } else {
      window.scrollTo(_currentY, targetY);
    }
    timer = null;
    clearTimeout(timer);
  }, 1);
};
const formatCardNo = card => {
  return card
    .replace(/\s/g, '')
    .replace(/[^\d]/g, '')
    .replace(/(\d{4})(?=\d)/g, '$1 ');
};

const emailIsValid = str => {
  const reg =
    // eslint-disable-next-line
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (reg.test(str)) {
    return true;
  }
  return false;
};

// 格式化日期
const formatDateEN = date => {
  const monthsInEng = [
    i18n.t('jan'),
    i18n.t('feb'),
    i18n.t('mar'),
    i18n.t('apr'),
    i18n.t('may'),
    i18n.t('june'),
    i18n.t('july'),
    i18n.t('aug'),
    i18n.t('sep'),
    i18n.t('oct'),
    i18n.t('nov'),
    i18n.t('dec'),
  ];
  const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
  return `${day} ${monthsInEng[date.getMonth()]} ${date.getFullYear()}`;
};

// 格式化时分
const formatHHmm = date => {
  let hour = date.getHours(),
    minute = date.getMinutes();
  hour = hour < 10 ? `0${hour}` : hour;
  minute = minute < 10 ? `0${minute}` : minute;
  return `${hour}:${minute}`;
};

// 获取用户设备或系统名
/* eslint-disable */
const getDeviceName = () => {
  let sys;
  let userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.match(/Windows NT 5.0/i) == 'windows nt 5.0') {
    sys = 'Windows 2000';
  } else if (userAgent.match(/Windows NT 5.1/i) == 'windows nt 5.1') {
    sys = 'Windows XP';
  } else if (userAgent.match(/Windows NT 5.2/i) == 'windows nt 5.2') {
    sys = 'Windows 2003';
  } else if (userAgent.match(/Windows NT 6.0/i) == 'windows nt 6.0') {
    sys = 'Windows Vista';
  } else if (userAgent.match(/Windows NT 6.1/i) == 'windows nt 6.1') {
    sys = 'Windows 7';
  } else if (userAgent.match(/windows nt 10.0/i) == 'windows nt 10.0') {
    sys = 'Windows 10';
  } else if (userAgent.indexOf('mac') > -1) {
    sys = 'Mac';
  } else if (userAgent.match(/android/i) == 'android') {
    sys = 'Android';
  } else if (userAgent.match(/iphone/i) == 'iphone') {
    sys = 'Iphone';
  } else {
    sys = 'Unknown';
  }
  return sys;
};

// 获取设备标识，本地不存在时生成并持久化，保证各接口、各流程使用同一个 deviceId
const getDeviceId = () => {
  let deviceId = localStorage.getItem('deviceId');
  if (!deviceId) {
    deviceId = uuid();
    localStorage.setItem('deviceId', deviceId);
  }
  return deviceId;
};

const updateQueryString = (uri, key, value) => {
  if (!value || !key) {
    return uri;
  }
  const reg = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
  const separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(reg)) {
    return uri.replace(reg, `$1${key}=${value}$2`);
  }

  return `${uri + separator + key}=${value}`;
};

const encryptString = async str => {
  const res = await context.config.globalProperties.$http.common.encryptPublicKey();
  let encryptStr = '';
  if (res.state === '11') {
    const KEY = res.data;
    const { pki } = window.forge;
    const publicKey = pki.publicKeyFromPem(
      `-----BEGIN PUBLIC KEY-----\n${KEY}\n-----END PUBLIC KEY-----`,
    );
    const bytes = window.forge.util.encodeUtf8(str);
    const encrypted = publicKey.encrypt(bytes, 'RSA-OAEP', {
      md: forge.md.sha256.create(),
      mgf1: {
        md: forge.md.sha256.create(),
      },
    });
    encryptStr = window.btoa(encrypted);
  }
  return encryptStr;
};

// const str2Bytes32 = str => {
//   if (!str) return;
//   const len = 32;
//   const buffer = Buffer.from(str, 'utf8');
//   const result = Array(len);
//   for (var i = 0; i < len; i++) {
//     result[i] = buffer[i];
//   }
//   return result;
// };

const str2Bytes32 = str => {
  if (!str) return;

  const len = 32;
  const buffer = new TextEncoder().encode(str); // Uint8Array

  const result = new Array(len).fill(0);
  for (let i = 0; i < len; i++) {
    result[i] = buffer[i];
  }
  return result;
};

const encryptAES = str => {
  const KEY = str2Bytes32(sessionStorage.getItem('_key'));
  const cipher = forge.cipher.createCipher('AES-CBC', KEY);
  cipher.start({ iv: KEY });
  cipher.update(util.createBuffer(str, 'utf8'));
  cipher.finish();
  return util.encode64(cipher.output.getBytes());
};

const decryptAES = encrypted => {
  const KEY = str2Bytes32(sessionStorage.getItem('_key'));
  const decipher = forge.cipher.createDecipher('AES-CBC', KEY);
  decipher.start({ iv: KEY });
  decipher.update(util.createBuffer(util.decode64(encrypted)));
  decipher.finish();
  return decipher.output.toString();
};

const arrContainAnotherArr = (bigArr, smallArr) => {
  return smallArr.every(item => bigArr.includes(item));
};

export {
  arrContainAnotherArr,
  getQueryString,
  formatCardNo,
  emailIsValid,
  formatDateEN,
  formatHHmm,
  getDeviceName,
  getDeviceId,
  scroll,
  showFirstChar,
  getFirst4andLast2Num,
  getEmailBeforeAt,
  getI18nLanguageName,
  getBrowserLanguageName,
  updateQueryString,
  encryptString,
  encryptAES,
  decryptAES,
};
